import ReCaptcha from './ReCaptcha';

export default ReCaptcha;